import React, { useState, useEffect } from 'react';
import { BsMoon, BsBrightnessHigh } from "react-icons/bs";

const getInitialTheme = () => {
  if (typeof window === 'undefined') return 'light';
  const stored = localStorage.getItem('theme');
  if (stored === 'dark' || stored === 'light') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

const ThemesToggle = () => {
  const [theme, setTheme] = useState(getInitialTheme);
  const isDark = theme === 'dark';

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  return (
    <button
      id="theme-toggle"
      className="btn theme_switch m-0"
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-pressed={isDark}
    >
      {isDark ? (
        <span className="light" aria-hidden="true"><BsBrightnessHigh /></span>
      ) : (
        <span className="dark" aria-hidden="true"><BsMoon /></span>
      )}
    </button>
  );
};

export default ThemesToggle;
